/**
 * Used in the case where the NFT collection name is not provided in the metadata
 *
 * Example: "Dappie Gang #60156f32" -> "Dappie Gang"
 */
export const convertNFTNameToCollectionName = (nftName?: string): string | undefined => {
  if (nftName) {
    return nftName.split("#")[0].trim();
  }

  return nftName;
};

/**
 * This is for the rare case where the project doesn't use the "collection" field at all
 * and instead places the collection name in the "description" field. These are manual
 * overrides
 *
 * This function should also be used in cases where convertNFTNameToCollectionName() provides
 * the wrong collection name, e.g. "Doggos #100" would not correctly convert into "Doggos NFTs"
 */
export const allowForDescriptionOverride = (description: string | undefined) => {
  const OVERRIDE_DESCRIPTIONS = ["Doggos NFTs"];

  if (!description) {
    return "";
  }

  if (OVERRIDE_DESCRIPTIONS.includes(description)) {
    return description;
  } else {
    return "";
  }
};
